import { ELECTRIC_USER_CONFIGS, USER_CONFIGS, USER_TYPES } from "./Auth.constants";
import { TAccount, TAccountState, TUserType } from "./Auth.types";

export const getUserType = (accountState: TAccountState): TUserType => {
  if (accountState?.modules?.facilities && accountState.modules.sensors) {
    return USER_TYPES.ALL;
  }
  else if (accountState?.modules?.facilities) {
    return USER_TYPES.OSOS;
  }
  else if (accountState?.modules?.sensors) {
    return USER_TYPES.SENSOR;
  }
  else {
    return USER_TYPES.ALL;
  }
};

export const getIsElectricUser = (account?: TAccount): boolean => {
  return account?.tags?.includes("elektrik") || false;
};

export const getUserConfig = (accountState: TAccountState) => {
  const { userType, account } = accountState;
  const isElectricUser = getIsElectricUser(account);

  return isElectricUser ? ELECTRIC_USER_CONFIGS : USER_CONFIGS[userType as TUserType];
};
